import { render, staticRenderFns } from "./collection-dynamic.vue?vue&type=template&id=2a54125a&"
import script from "./collection-dynamic.vue?vue&type=script&lang=js&"
export * from "./collection-dynamic.vue?vue&type=script&lang=js&"
import style0 from "./collection-dynamic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports